<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form" >
<!--                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" placeholder="关键词"></el-input>
                </el-form-item>-->
                <el-form-item label="类型">
                    <el-select v-model="form.type" clearable  placeholder="全部">
                        <el-option label="兑换" :value="1"></el-option>
                        <el-option label="消耗" :value="2"></el-option>
                        <el-option label="返还" :value="3"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    min-width="180"
                    prop="userName"
                    label="兑换人" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="typeName"
                    label="类型" >
                </el-table-column>
                <el-table-column
                    prop="changeValue"
                    min-width="120"
                    label="创新币" >
                </el-table-column>

                <el-table-column
                    width="160"
                    label="封面">
                    <template slot-scope="scope" v-if="scope.row.type != 1">
                        <el-image
                            style="width: 150px; height: 90px"
                            :src="scope.row.exchangeRecord.goods.coverImg"
                            :lazy="true"
                            :preview-src-list="[scope.row.coverImg]"
                            fit="fill"></el-image>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="180"
                    label="商品" >
                    <template slot-scope="scope" v-if="scope.row.type != 1">
                        {{scope.row.exchangeRecord.goods.name}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    min-width="120"
                    label="创建时间" >
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>
    </div>
</template>

<style scoped>

</style>
<style>

</style>

<script>
import {mapState, mapMutations} from "vuex";

export default {
    components: {
    },
    props: [
        "attr"
    ],
    data() {
        return {
            form: {
                keywords: "",
                enable:true
            },
            pager: {
                pageSize: 12,
                dataTotal: 0,
                currentPage: 1
            },
            tableData: [],
        }

    },

    watch: {
        "form": {
            handler: function (newValue) {
                this.pager.currentPage = 1;
                this.loadData();
            },
            deep: true

        }
    },

    methods: {
        loadData() {
            this.$ajaxPost("/innovateScore/list", {
                form: this.form,
                pager: {...this.pager, dataTotal: 0}
            }, (data) => {
                //分页不能带offset，否则会影响后台计算最新offset
                let {offset, ...pager} = data.pager;
                this.pager = pager;
                this.tableData = data.result;
            })
        },
        pageChange(page) {
            this.pager.currentPage = page;
            this.loadData();
        },
    },
    created() {
        this.loadData();
    }

}
</script>
